import { render, staticRenderFns } from "./KycProofOfAddress.vue?vue&type=template&id=af54c854&scoped=true&"
import script from "./KycProofOfAddress.vue?vue&type=script&lang=js&"
export * from "./KycProofOfAddress.vue?vue&type=script&lang=js&"
import style0 from "./KycProofOfAddress.vue?vue&type=style&index=0&id=af54c854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af54c854",
  null
  
)

export default component.exports